import { doordashInstacartExtensionId } from '@/constants/doordashInstacartExtension';

const callerMessageKind = 'caller';
const excludedRoles = new Set(['customer', 'family', 'partner', 'affiliate']);

export const sendCallerToExtension = (caller?: { id?: string | null; phoneNumber?: string | null } | null) => {
  if (!caller?.id || !caller.phoneNumber) {
    return;
  }

  try {
    const roles = JSON.parse(localStorage.getItem('roles') || 'null');
    if (!Array.isArray(roles) || roles.length === 0 || roles.some((role) => typeof role !== 'string' || excludedRoles.has(role))) {
      return;
    }
  } catch {
    return;
  }

  if (!globalThis.chrome?.runtime) {
    return;
  }

  chrome.runtime.sendMessage(doordashInstacartExtensionId, { kind: callerMessageKind, phoneNumber: caller.phoneNumber }, () => {
    void chrome.runtime.lastError;
  });
};
